import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  orderCancelAndRefundUsingMultipleVoucher,
  orderEligibilitiesMockEligibleToInvoluntaryRefundUsingMultipleVoucherButOnlyOneIsEligible,
  orderEligibilitiesMockEligibleToRefundUsingMultipleVoucherButOnlyOneIsEligible,
  orderMockEligibleToRefundUsingMultipleVouchers,
} from '../../../mock/data/index';

/**
 * Mocks for refundable order using multiple vouchers.
 */
export const eligibleToRefundUsingMultipleVouchersMock: MockMap = {
  retrieveOrder: [createMockData(orderMockEligibleToRefundUsingMultipleVouchers)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleToRefundUsingMultipleVoucherButOnlyOneIsEligible)],
  cancelAndRefundOrder: [createMockData(orderCancelAndRefundUsingMultipleVoucher)]
};

/**
 * Mocks for refundable order using multiple vouchers.
 */
export const eligibleToInvoluntaryRefundUsingMultipleVouchersMock: MockMap = {
  retrieveOrder: [createMockData(orderMockEligibleToRefundUsingMultipleVouchers)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleToInvoluntaryRefundUsingMultipleVoucherButOnlyOneIsEligible)],
  cancelAndRefundOrder: [createMockData(orderCancelAndRefundUsingMultipleVoucher)]
};
